// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 justify-center>
        <item-list
        allowAdd
        allowDelete
        :endpoint="endpoint + 'accessRules'"
        editRoute="ruleEdit"
        :headers="headers"
        name="Rule"
        :searchBarText="searchBarText"
        permissions='accessRules'
        ></item-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import ItemList from 'vue-common/components/ItemList.vue'

import {ENDPOINT} from '@/shared/constants'
import {PERMISSIONS, WILDCARDBSON} from 'vue-common/components/constants'
import {getUserRolesText} from 'vue-common/components/utils'

export default {
  components: {
    ItemList
  },

  props: {
    searchBarText: String
  },

  data () {
    return {
      endpoint: ENDPOINT,
      headers: [
        {
          text: 'Resource Type',
          value: 'resourceType'
        },
        {
          text: 'Resource ID',
          value: 'resourceID'
        },
        {
          text: 'Permissions',
          value: 'permissions',
          function: this.permissionsToText
        },
        {
          text: 'Role ID',
          value: 'roleID',
          function: this.rolesToText,
          context: ENDPOINT + 'roles'
        }
      ]
    }
  },

  methods: {
    rolesToText: function (rule, roles) {
      if (rule.roleID === WILDCARDBSON) {
        return 'Global'
      } else {
        var list = [rule.roleID]
        return getUserRolesText(list, roles)
      }
    },

    permissionsToText: function (rule) {
      var permission = rule.permissions
      if (permission === PERMISSIONS.READ) {
        return 'Read'
      } else if (permission === PERMISSIONS.MODIFY) {
        return 'Modify'
      } else if (permission === PERMISSIONS.CREATE) {
        return 'Create'
      } else if (permission === PERMISSIONS.DELETE) {
        return 'Delete'
      }
      return ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Rules.vue